export enum SessionStorageKeysEnum {
    CriteriaChanged = 'criteriaChanged',
}
